export default {"src":"/_next/static/media/initial.ae463105.svg","height":493,"width":708,"blurWidth":0,"blurHeight":0};